
/* eslint-disable */
import { mapMutations, mapGetters } from "vuex";
import configVars from "@/config/config_vars";
let appBaseUrl = configVars.appBaseUrl;

export default {
  name: "EnjoyVIPPriceModal",
  components: {},
  computed: mapGetters({
    user: "user/user",
    isAutenticated: "user/isAutenticated",
    imgSrc: "user/imgSrc",
    follow: "follow"
  }),
  data() {
    return {



    };
  },
  props: {
   

  },

  mounted() {
    document.addEventListener("keydown", e => {
      if (e.keyCode == 27) {
        this.close();
      }
    });
    this.$nextTick(async () => {
      
    })
  },
  watch: {},
  methods: {
    nextButtonClick() {
      this.$emit("nextButtonClick");
      this.close();
    },
    close() {
      this.$emit("close")

    },
    open(){
      this.$emit("open")
    },

  }
};
